import {
    Events_Events_TableOfObjects_Widget_Reducer_Values,
    storeSelectedComparePeriod,
    storeSelectedObjectsType,
    storeTableSortData,
    reloadWidget,
} from './reducer';
import { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IComparePeriod, ITableSortData } from './interfaces';
import Table from './components/Table/Table';
import { TableWrapper } from './styles';
import { generalReducerValues } from '../../../../../../../General.reducer';
import { useRerender } from '../../../../../../../tools/useRerender';
import { useWidgetCurrentOptions } from '../../../../../../../tools/useWidgetCurrentOptions';
import { TableOfObjectsContext } from './context';
import Header from './components/Header/Header';
import SubHeader from './components/SubHeader/SubHeader';

/**
 * Компонент для отображения виджета Leasing:Tenants
 */
const TableOfObjects = memo(() => {
    const localCurrentOptions = useWidgetCurrentOptions('Events:Events');
    const {
        cfg: { tenant2ZoneByTenantId, tenant2FloorByTenantId, reportingObjectsById, reportingObjectsByType },
        src: { dataObj2ProjectCategory },
        allMetrics,
    } = useSelector(generalReducerValues);
    const {
        extendedReportingObjects,
        availableComparePeriods,
        selectedComparePeriod,
        selectedObjectsType,
        rawMetricsData,
        tableSortData,
    } = useSelector(Events_Events_TableOfObjects_Widget_Reducer_Values);
    const rerender = useRerender(extendedReportingObjects);
    const rootNodeRef = useRef(null);
    const dispatch = useDispatch();

    const storeTableSortDataTrans = (data: null | ITableSortData) => {
        dispatch(storeTableSortData(data));
    };

    const storeSelectedObjectsTypeTrans = (selectedObjectsType: string) => {
        dispatch(storeSelectedObjectsType(selectedObjectsType));
    };

    const storeSelectedComparePeriodTrans = (comparePeriod: IComparePeriod) => {
        dispatch(storeSelectedComparePeriod(comparePeriod));
    };

    const context = {
        selectedMetrics: localCurrentOptions?.selectedMetrics,
        mainDateRanges: localCurrentOptions?.mainDateRanges,
        mainPeriod: localCurrentOptions?.mainPeriod,
        filters: localCurrentOptions?.['filters'],
        extendedReportingObjects,
        dataObj2ProjectCategory,
        availableComparePeriods,
        reportingObjectsByType,
        tenant2FloorByTenantId,
        tenant2ZoneByTenantId,
        selectedComparePeriod,
        reportingObjectsById,
        selectedObjectsType,
        tableSortData,
        rootNodeRef,
        allMetrics,
        rerender,
        storeSelectedComparePeriodTrans,
        storeSelectedObjectsTypeTrans,
        storeTableSortDataTrans,
        reloadWidget,
    };

    return (
        <TableOfObjectsContext.Provider value={context}>
            <div ref={rootNodeRef}>
                <Header />
                <SubHeader />
                <TableWrapper>
                    <Table />
                </TableWrapper>
            </div>
        </TableOfObjectsContext.Provider>
    );
});

export default TableOfObjects;
